<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_TEMPLATE'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>

  <button mat-raised-button color="warn" (click)="delete()" *LOSxHasPermission="'DELETE_TEMPLATE'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.name' | translate }}
        </div>

        <div class="flex-50">
          {{ templateData.name }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Entity' | translate }}
        </div>

        <div class="flex-50">
          {{ templateData.entity }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Type' | translate }}
        </div>

        <div class="flex-50">
          {{ templateData.type }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Text' | translate }}
        </div>

        <div class="flex-50" [innerHTML]="templateData.text"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
